import { PcbNodeTypes } from "@buildwithflux/models";
import { Clipper } from "../../../../clipper";
import { removePolyHoles } from "../../../../common";
import { nodeHasFillOnLayer } from "../../../../fills";
import { getAncestorUidByType, getTopLevelLayoutOfNode, PcbNodeHelper } from "../../../../nodes";
import { createLayoutShape } from "../../../../shapes";
import { toKicadPolygon } from "./support/polygonHelpers";
export const mapFill = (fill, context, _postprocess, treeNodes) => {
    const br = fill.bakedRules;
    if (!br) {
        throw new Error("Attempt to export unbaked fill. Should never reach this code.");
    }
    const fillParentNodeUid = 
    // Please please please do NOT change this ?? into ||
    (PcbNodeHelper.isVirtualNode(fill) && fill.virtualNodeInfo?.originNodeUid) ||
        // to make old tests pass (natarius-pad-permutations)
        getAncestorUidByType(treeNodes, fill.uid, PcbNodeTypes.net);
    const fillParentNode = fillParentNodeUid ? treeNodes[fillParentNodeUid] : undefined;
    if (!fillParentNodeUid ||
        !fillParentNode ||
        (fillParentNode.type !== PcbNodeTypes.net && fillParentNode.type !== PcbNodeTypes.polygon)) {
        throw new Error("Fills outside net/polygon nodes cannot be exported");
    }
    const netUid = fill.bakedRules.effectiveNetId ?? fill.parentUid;
    const netNode = fillParentNodeUid ? treeNodes[netUid] : undefined;
    const netNumber = context.nodes.net?.[netUid]?.net_number ?? undefined;
    if (netNumber === undefined) {
        throw new Error(`Cannot find mapped net for fill ${fill.uid} (net ID: ${netUid})`);
    }
    const layout = getTopLevelLayoutOfNode(treeNodes, netUid);
    if (!layout || !layout.bakedRules) {
        throw new Error("Cannot export copper fills without valid Layout node");
    }
    const layoutShape = layout.type === PcbNodeTypes.layout && createLayoutShape(layout.bakedRules);
    if (!layoutShape) {
        throw new Error("Layout has no valid shape; cannot export copper fill");
    }
    const stackup = Object.values(layout.bakedRules.stackup ?? {});
    const fillLayers = stackup.filter((l) => nodeHasFillOnLayer(fillParentNode, l));
    const zones = [];
    for (const layer of fillLayers) {
        const shapeMapFills = context.fillShapes[fillParentNodeUid]?.[layout.uid]?.[layer.uid] ?? [];
        const fillShape = Clipper.shape(shapeMapFills);
        const shapes = fillShape.separateShapes();
        const polygons = shapes.reduce((polygons, shape) => {
            const [first, ...rest] = shape.toPolygons();
            if (first) {
                polygons.push(removePolyHoles(first, rest));
            }
            return polygons;
        }, []);
        const kicadFilledPolygon = polygons.map((p) => toKicadPolygon(p, layout.bakedRules.positionRelativeToDocument, layout.bakedRules.rotationRelativeToDocument));
        const kicadPolygon = [layoutShape.getPoints(64)].map((p) => toKicadPolygon(p, layout.bakedRules.positionRelativeToDocument, layout.bakedRules.rotationRelativeToDocument));
        const kicadLayer = context.getKiCadLayerByLayerIdentifier(fill.uid, layer.name);
        // Just remove any fills that are on layers that don't exist in the KiCad layer stack
        // We already report this case in DRC
        if (!kicadLayer) {
            continue;
        }
        zones.push({
            tstamp: layer.uid,
            layer: kicadLayer,
            net: netNumber?.toString() ?? "",
            net_name: netNode?.name ?? "",
            hatch: { style: "none", pitch: 0 },
            connect_pads: { clearance: 0 },
            min_thickness: "0",
            fill: { arc_segments: 0, thermal_gap: 0, thermal_bridge_width: 0, filled: false },
            polygon: kicadPolygon,
            filled_polygon: kicadFilledPolygon,
        });
    }
    return zones;
};
//# sourceMappingURL=mapFill.js.map